import React, {useEffect} from "react";

import Navbar from "./components/navbar/Navbar";
import RouterPage from "./routes/RouterPage";
import Footer from "./components/footer/Footer";
import {
  bgBlur,
  footImg,
  bgBlur2,
  devopsBG,
  businessBG,
  websiteBG,
  uiUxBG,
  bgOurTeam,
} from "./data/assetes";

import {banner2} from "./data/assetes";
import {useLocation} from "react-router-dom";
import Banner from "./components/banner/Banner";
import Section13 from "./components/hero_sections/Section13";
import Section6 from "./components/hero_sections/Section6";

const App = () => {
  let container = "max-w-7xl mx-auto";

  const location = useLocation();

  let style = {};
  const gradientStyle = {
    background:
      "linear-gradient(261.39deg, rgba(254, 187, 77, 0.5) 0.6%, rgba(255, 237, 207, 0.5) 15.85%, rgba(254, 220, 165, 0.5) 24.28%, rgba(252, 199, 112, 0.5) 32.74%, rgba(254, 187, 77, 0.5) 46.07%, rgba(254, 201, 114, 0.404237) 67.03%, rgba(255, 216, 153, 0.306318) 78.79%, rgba(255, 226, 177, 0.188318) 81.36%, rgba(255, 233, 196, 0.1) 100%)",
    width: "100%",
    paddingBottom: "10px",
  };

  const gradientStyle2 = {
    background:
      "linear-gradient(261.39deg, rgba(255, 235, 203, 0.5) 0.6%, rgba(250, 219, 169, 0.5) 15.85%, rgba(255, 217, 154, 0.5) 46.07%, rgba(255, 216, 153, 0.306318) 80.92%, rgba(255, 233, 196, 0.1) 100%)",
    width: "100%",
    paddingBottom: "10px",
  };

  const gradientStyle3 = {
    backgroundImage: `url(${devopsBG})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    paddingBottom: "10px",
  };

  const gradientStyle4 = {
    backgroundImage: `url(${businessBG})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    paddingBottom: "10px",
  };

  const gradientStyle5 = {
    backgroundImage: `url(${websiteBG})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    paddingBottom: "10px",
  };

  const gradientStyle6 = {
    backgroundImage: `url(${uiUxBG})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    paddingBottom: "10px",
  };

  const gradientStyle7 = {
    backgroundImage: `url(${bgOurTeam})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    paddingBottom: "10px",
  };

  if (location.pathname === "/") {
    style = {
      backgroundColor: "#FFFAF3",
    };
  } else if (location.pathname === "/ai-development") {
    style = gradientStyle;
  } else if (location.pathname === "/software-development") {
    style = gradientStyle2;
  } else if (
    location.pathname === "/devops" ||
    location.pathname === "/salesforce"
  ) {
    style = gradientStyle3;
  } else if (location.pathname === "/business-modernization") {
    style = gradientStyle4;
  } else if (location.pathname === "/website-development") {
    style = gradientStyle5;
  } else if (location.pathname === "/ui-ux-design") {
    style = gradientStyle6;
  } else if (location.pathname === "/our-team") {
    style = gradientStyle7;
  } else {
    style = {
      backgroundImage: `url(${banner2})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "100%",
      paddingBottom: "10px",
    };
  }

  // background: ;

  // Scroll to top on route change
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({top: 0, left: 0, behavior: "auto"});
    }
  }, [location.pathname]);

  return (
    <div>
     
      {/* Header */}
      <div className="relative px-2" style={style}>
        <div className={container}>
          <Navbar />
          <Banner container={container} location={location} />
        </div>
        {location.pathname === "/about" && (
          <img
            src={bgBlur}
            alt="bgBlur"
            className="absolute bottom-0 right-0 w-48 "
          />
        )}

        {location.pathname === "/testimonials" && (
          <img
            src={bgBlur2}
            alt="bgBlur2"
            className="absolute bottom-0 right-20 h-[270px] w-[45%] z-50 "
          />
        )}
      </div>

      {/* Routes */}
      <div className="">
        <RouterPage container={container} />
      </div>

      {/*Footer */}
      <div className="bg-primary border-t-4 border-secondary">
        <div className={container}>
          <Section6 />
          <Section13 />
          <Footer container={container} />
        </div>
        <div
          className="w-full h-[173px] bg-cover bg-center bg-no-repeat flex justify-center items-end"
          style={{backgroundImage: `url(${footImg})`}}
        >
          <div className=" text-center text-sm">Copyright © 2025 Cybdeer</div>
        </div>
      </div>
    </div>
  );
};

export default App;
